import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { ScheduledTask, ScheduledTaskCreate } from '@features/cron/types'

import { taskCatalogQueryKey } from '../queries/useTaskCatalog'
import { scheduledTasksQueryKey } from '../queries/useScheduledTasks'

export function useCreateScheduledTask() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError()
  const { t } = useTranslation('cron')

  async function create({ body }: { body: ScheduledTaskCreate }) {
    const res = await apiClient.post<ScheduledTask>(
      BACK_OFFICE_PREFIX + 'scheduled-tasks',
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: create,
    onSuccess: () => {
      toast.success({ message: t('toast.created') })
      queryClient.invalidateQueries({ queryKey: scheduledTasksQueryKey })
      queryClient.invalidateQueries({ queryKey: taskCatalogQueryKey })
    },
    onError
  })
}
